import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { redirectOnDomainMatch } from './redirect-on-domain-match';
import 'assets/css/fonts.css';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

redirectOnDomainMatch(() => {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
